import React from "react";
import { useState, useEffect } from "react";

export default function Home() {
  const [width, setWidth] = useState(window.innerWidth);

  const updateWidthAndHeight = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  });
  return (
    <div className="top-margin">
      {/* <!--IMAGE--> */}
      <section id="homeBody">
        <div className="organisationImg">
          {width > 768 ? (
            <div className="ieeeImage">
              <img
                src="./images/AICTE.jfif"
                className="img-fluid"
                alt="IEEE_logo"
                id="logo"
              />
              <img
                className="response img-fluid"
                src="./images/kncet header.png"
                alt="kncet_logo"
                id="clg"
              />
              <img
                src="./images/MOE Logo.png"
                className="img-fluid"
                alt="MOE_logo"
                id="logo2"
              />
            </div>
          ) : (
            <div>
              <div className="header_mobile">
                <img
                  className="response img-fluid"
                  src="./images/header_up.png"
                  alt="kncet_logo"
                  id="kncet_logo"
                />
                <img
                  className="response img-fluid"
                  src="./images/header_down.png"
                  alt="kncet_logo"
                  id="clg"
                />
              </div>
              <br />
              <div className="ieeeImage_mobile">
                <img
                  src="./images/AICTE.jfif"
                  className="img-fluid"
                  alt="IEEE_logo"
                  id="logo"
                />

                <img
                  src="./images/MOE Logo.png"
                  className="img-fluid"
                  alt="MOE_logo"
                  id="logo2"
                />
              </div>
            </div>
          )}
        </div>
        <div className="kncethome">
          <a
            href="http://www.kongunadu.ac.in"
            title="http://www.kongunadu.ac.in"
          >
            <button type="button" className="btn btn-outline-primary">
              KNCET HOME
            </button>
          </a>
        </div>
        <br />

        <div className="container">
          <article id="title_design">
            <h1>
              AICTE Sponsored International Conference on Emerging Trends in
              Communication and Networking (ETCAN’21)
            </h1>
            <p>Organized by</p>
            <p>Department of ECE</p>
            <p>
              22nd-23<span id="rd">rd</span> October 2021
            </p>
          </article>
        </div>
        {/* <!--/IMAGE--> */}

        {/* <!--BODY--> */}
        <div className="about">
          <div className="card border-primary mb-3" style={{ width: "auto" }}>
            <div className="card-body">
              <h5
                className="card-title text-primary"
                style={{
                  textDecoration: "underline",
                  fontWeight: "bolder",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                ABOUT THE CONFERENCE
              </h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <p className="card-text">
                The vision of the International Conference on Emerging Trends in
                Communication and Networking (ETCAN)’21 is an opportunity for
                the participants to discuss the recent developments and
                challenges faced by the community in the 21st century in the
                area of Communication and Smart Networking. It also provides the
                leading interdisciplinary forum for scientists, engineers,
                industrialists and researchers to present their latest research
                idea, applications and innovations in communication and
                networking. The Conference invites industry persons and
                professors from IITs / IISCs / NITs / Government / Private
                institutions to provide keynote addresses in the relevant fields
                and to review, give suggestions to the author’s articles. All
                full paper submissions will be peer reviewed, best articles will
                be identified and awarded during the conference. Surely, the
                outcome of this conference will kindle the mindset of Research
                scholars, Faculty Members, Students and Industry Persons to
                learn and promote their research work in the thrust areas of
                communication and networking. The faculty, research scholars and
                students from Electronics & Communication, Computer Science,
                Information Technology and Electrical and Electronics
                Engineering are invited to submit the articles to this
                conference.
              </p>
            </div>
          </div>
        </div>

        <div className="about">
          <div className="card border-primary mb-3" style={{ width: "auto" }}>
            <div className="card-body">
              <h5
                className="card-title text-primary"
                style={{
                  textDecoration: "underline",
                  fontWeight: "bolder",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                ABOUT THE COLLEGE
              </h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <p className="card-text">
                Kongunadu College of Engineering and Technology (KNCET) was
                established in the year 2007 ,having world class infrastructure
                for students best career growth in peaceful ambience for
                Academic, Research, Employability and Entrepreneurial culture as
                par with global competency. Our institute provides good
                opportunities to develop the student's interpersonal skills
                through various clubs & activities to make them industry ready
                as well as versatile personalities in real life. Our institution
                is having Learning Rooms with Multimedia, Visual Equipments,
                Digital Library and Modernized Laboratories.
              </p>
              <p className="card-text">
                Our institution is an Autonomous, self financing Engineering
                College, Approved by AICTE, New Delhi, Affiliated to Anna
                University, Chennai, Accredited by NBA(CSE,ECE,& EEE),NAAC,
                Recognized by UGC with 2(f) & 12(B) and certified by ISO
                9001:2015.
              </p>
              <p className="card-text">
                The college is having 9 UG courses such as B.E Agriculture
                Engineering, B.Tech Artificial Intelligence and Data Science,B.E
                Bio Medical Engineering, B.E Civil Engineering, B.E Computer
                Science and Engineering, B.E Electronics and Communication
                Engineering, B.E Electrical and Electronics Engineering, B.Tech
                Information Technology, B.E Mechanical Engineering and 2 PG
                Courses such as M.E Applied Electronics and M.E Computer Science
                and Engineering.Permanent affiliation has been obtained for ECE,
                Mechanical, CSE and EEE & Civil departments.
              </p>
              <p className="card-text">
                Anna University has approved the research centre to the
                Department of Electronics and Communication Engineering during
                2016. Our institute is recognized as a Host Institute for
                business incubation by the Ministry of Micro, Small and Medium
                Enterprises (MSME) during 2021.
              </p>
              <p className="card-text">
                An exclusive Placement Cell C to C (Campus to Corporate)
                department is functioning whose main motto is to build potential
                expertise in students and to evolve them into successful
                aspirants. It creates many job avenues for the students and acts
                as a transformer between the college and the corporates. C to C
                has been patterned with a view to give a complete corporate look
                to our budding job seekers. Every year, this team providing 90%
                and above job opportunities to students in various reputed MNCs
                like TCS, Infosys, Wipro, CTS, Zoho, Accenture, Visteon,FIS,
                Msys, Tech Mahindra, Syrma,Voltech,TVS group,Nu Technologies,8K
                miles, Episource, Aspire, Daebu,PSK, PST, Ashok,GRM
                Constructions, Mitsuba, Sutherland etc.,
              </p>
              <p className="card-text">
                The following Centre of Excellence is continuously supported to
                Faculty Members and Students to update their skills for
                converting their ideas into Prototype/Product.
              </p>
              <div style={{ marginLeft: "3%" }}>
                <ol id="listStyle">
                  <li> AICTE Sponsored MODROBS- IoT Lab</li>
                  <li> PCB Design and Development Centre</li>
                  <li> Signal Processing & Networking</li>
                  <li> Dell EMC Data Science and Big Data Analytics</li>
                  <li> Cisco Networking Academy</li>
                  <li> TVS Harita</li>
                  <li>
                    {" "}
                    IoT and Embedded systems laboratory [Texas Instruments and
                    ABE Semiconductor Designs]
                  </li>
                  <li>
                    {" "}
                    Industrial Automation laboratory [Powered by Siemens and
                    Mitsubishi]
                  </li>
                  <li> Centre for Energy Studies</li>
                </ol>
              </div>
              <p className="card-text">
                The college has received research grants from Funding Agencies
                such as AICTE,DST,NIMAT-DST, CSIR, TNSCST, SERB, ISRO & EDC for
                doing Projects, organizing National & International Conferences,
                conducting Entrepreneurship Awareness Camp, Guest Lectures,
                Seminars and Workshops. Consultancy works have been undertaken
                from various industries.
              </p>
              <strong>Awards and Recognitions:</strong>
              <div style={{ marginLeft: "3%" }}>
                <ol id="listStyle">
                  <li>
                    Times Engineering Survey 2021: Top 175 Engineering
                    institutes in India and Top 25 Engineering institutes in
                    Tamilnadu
                  </li>
                  <li>
                    Careeres360 2021 Ranking : “AAA" rating among top
                    Engineering institutes in India
                  </li>
                  <li>
                    Intellectual Property (IP) Award-2019 from Anna University
                    ,Chennai
                  </li>
                  <li>
                    Recognition in IIT Madras- IDEA SPARK competitions- 2019.
                  </li>
                  <li>AICTE Clean and Smart Campus Award – 2019</li>
                  <li>AICTE Utkrisht Sansthan Vishwakarma Award 2019</li>
                  <li>AICTE Chhatra Vishwakarma Award 2019.</li>
                  <li>
                    Innovative Banana Product 2019 from ICAR-National Research
                    Centre for Banana, Trichy.
                  </li>
                  <li>
                    Active SPOC Recognition during 2019 in NPTEL Examination
                    registration 2019
                  </li>
                  <li>
                    Active SPOC for spreading IIT Spoken Tutorials, an Intiative
                    of National Mission on Education through ICT, MoE,Govt.of
                    India during 2019.
                  </li>
                  <li>Appreciation from Texas Instuments -2019</li>
                  <li>
                    Recognition in AICTE National Startup-Summit IISF -2017.
                  </li>
                  <li>5 s Platinum Award 2015</li>
                  <li>CISCO Academy of 5 Years of Service Award-2018</li>
                  <li>
                    ISTE Best Student Award 2019 & 2020 ,Dewang Mehta Award
                    2017, Dr.Kalams Best Student Award 2019, Appreciation for
                    IEEE Activities 2020
                  </li>
                  <li>
                    Best N.S.S Unit Award for College, Best N.S.S Volunteer
                    Award and Best N.S.S Program Officer ward for our Faculty
                    2019
                  </li>
                  <li>
                    14th position among Anna University affiliated Engineering
                    colleges based on the university academic result pass
                    percentage during November/December 2016
                  </li>
                  <li>
                    Innovative Ideas are selected in Smart India Hackathons 2018
                    & 2019 ,Toy-Cathon 2021 and achieved many prizes by our
                    students through various competitions such as symposium and
                    conferences
                  </li>
                  <li>30 Patents and 06 Industrial Designs</li>
                  <li>
                    24 MoU’s with various research institutes and Industries
                  </li>
                  <li>Many more ….</li>
                </ol>
              </div>
              <p className="card-text">
                Kongunadu Innovation Council (KIC) is framed to promote
                innovation and entrepreneurship culture among students and
                Faculty Members through the Ministry of Education, Institution
                Innovation Council (IIC), and New Delhi. Kongunadu Innovation
                and Start-up Policy (KNISP’21) is created based on National
                Innovation and Startup Policy, Tamil Nadu Start-up Policy and
                Anna University. Our institute provides an Incubation support
                for start-up for our students, alumni, faculty and outside
                entrepreneurs.
                <br />
                <br />
                Faculty members and students are doing online courses through
                NPTEL,UDEMY,Edureka and etc.,Totally 98 NPTEL courses by faculty
                members have been successfully completed.1730 students have
                received certificate from IIT Spoken Tutorials.
                <br />
                <br />
                The institute has a world class indoor stadium and sufficient
                no. of playgrounds for various games. The college has attained
                first position in overall championship in games and sports in
                zone 8 (Salem Zone) during the year,2018-19, 2016-17 and
                2015-16. <br />
                <br />
              </p>
              <div style={{ marginLeft: "3%" }}>
                <ol id="listStyle">
                  <li>Green Environment and High-Tech Infrastructure.</li>
                  <li>24 hours Power back up with 1120 KVA.</li>
                  <li>
                    Reverse Osmosis (RO) Water Plant and Recycled Water System
                    for gardening.
                  </li>
                  <li>Learning Rooms with Multimedia and Visual Equipments.</li>
                  <li>
                    Digital Library and Modernized Laboratories, Wi-Fi
                    Connectivity with100 Mbps.
                  </li>
                  <li>
                    Transportation: 53 Buses cover Namakkal, Trichy & Karur
                    Districts.
                  </li>
                  <li>
                    Hostel and Residential Facilities with Solar Water Heater,
                    LCD TV, Laundry Plant, etc.
                  </li>
                  <li>
                    Modern Men and Women Gym covering 3000 sq.ft with Modernized
                    Instruments and Equipments. Well equipped Dining Hall and
                    Hygienic Cafeteria
                  </li>
                  <li>
                    Clubs – NSS, YRC, RRC, English Blossom, Tamil Mandram, Music
                    Club, Nature's Club, RETC, Multimedia Club, Science Club.
                  </li>
                  <li>
                    Cells - R&D Cell, Entrepreneur Development Cell, Innovation
                    Council Cell, Editorial Board Cell, Industry Institute
                    Partnership Cell, Women Development Cell, Internal Quality
                    Assurance Cell & Higher Educational Cell.
                  </li>
                  <li>Professional bodies –IETE, IEEE, ISTE, CSI & SAE</li>
                  <li>
                    Indoor Stadium exclusively for Riffle Range, Ball Badminton,
                    Basket Ball, Carrom, Table Tennis, Chess, Shuttle Badminton,
                    Fencing, Boxing, Weight Lifting, Squash, Billiards and
                    Tennis and separate GYMs for Boys and Girls.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
